/* assets/min-qty.js — hard-floor min */
(function () {
  'use strict';

  // Flip to false if you want to allow typing below min until blur.
  const STRICT_MIN_ON_INPUT = false;

  const STATE = { enhanced: new WeakSet() };

  function readRules(root) {
    const tag =
      root.querySelector?.('[id^="minQtyByVariant-"]') ||
      document.querySelector('[id^="minQtyByVariant-"]');
    try { return tag ? JSON.parse(tag.textContent) : {}; } catch { return {}; }
  }

  function toNum(v, d = NaN) {
    const n = Number(v);
    return Number.isFinite(n) ? n : d;
  }

  function clampToStep(val, min, step) {
    val = Math.max(val, min);
    step = Math.max(1, Number(step) || 1);
    if (step > 1) {
      const over = (val - min) % step;
      if (over !== 0) val = val - over + step;
    }
    return val;
  }

  function ruleFor(variantSel, RULES) {
    const id = variantSel?.value;
    const r = (id && RULES[id]) ? RULES[id] : { min: 1, step: 1 };
    const min = Math.max(1, Number(r.min) || 1);
    const step = Math.max(1, Number(r.step) || 1);
    return { min, step, hasStep: step > 1 };
  }

  function applyRulesToForm(form, RULES) {
    if (STATE.enhanced.has(form)) return;
    STATE.enhanced.add(form);

    const qty = form.querySelector('input[name="quantity"]');
    if (!qty) return;

    const variantSel = form.querySelector('[name="id"]');

    function enforceMinNow() {
      const { min } = ruleFor(variantSel, RULES);
      const n = toNum(qty.value, NaN);
      if (!Number.isFinite(n) || n < min) {
        qty.value = String(min);
        // fire a change so any bindings/theme UI refresh
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function setAttrs() {
      const { min } = ruleFor(variantSel, RULES);
      // Keep native +/- smooth; we enforce packs on blur/submit.
      qty.min = String(min);
      qty.step = '1';
      // Always floor to min immediately if under.
      enforceMinNow();
    }

    // Init: set attributes and floor to min if needed
    setAttrs();

    // While typing: always floor to min if it dips under (optional via flag)
    qty.addEventListener('input', () => {
      if (!STRICT_MIN_ON_INPUT) return;
      const { min } = ruleFor(variantSel, RULES);
      const n = toNum(qty.value, NaN);
      if (!Number.isFinite(n) || n < min) {
        qty.value = String(min);
      }
    });

    // On blur/change: enforce min + pack size if configured
    qty.addEventListener('change', () => {
      const { min, step, hasStep } = ruleFor(variantSel, RULES);
      let n = toNum(qty.value, min);
      if (n < min) n = min;
      if (hasStep) n = clampToStep(n, min, step);
      qty.value = String(n);
    });

    // Variant change: refresh attributes and floor to min
    variantSel && variantSel.addEventListener('change', setAttrs);

    // Submit guard (product page & quick-add)
    form.addEventListener('submit', (e) => {
      const { min, step, hasStep } = ruleFor(variantSel, RULES);
      const raw = toNum(qty.value, min);
      const corrected = hasStep ? clampToStep(raw, min, step) : Math.max(raw, min);

      if (raw < min || raw !== corrected) {
        e.preventDefault();
        qty.value = String(corrected);
        showMsg(form, `Minimum is ${min}${hasStep ? ` (order in ${step}s)` : ''}. Adjusted for you.`);
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    function showMsg(form, text) {
      let el = form.querySelector('.min-qty-msg');
      if (!el) {
        el = document.createElement('p');
        el.className = 'min-qty-msg';
        el.style.color = '#dc2626';
        el.style.marginTop = '0.5rem';
        form.appendChild(el);
      }
      el.textContent = text;
    }
  }

  function enhance(root = document) {
    const RULES = readRules(root);
    root.querySelectorAll('form[action*="/cart/add"]').forEach(f => applyRulesToForm(f, RULES));
  }

  document.addEventListener('DOMContentLoaded', () => enhance());

  // Handle Savor dynamic renders (drawers/sections)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (!m.addedNodes?.length) continue;
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.('form[action*="/cart/add"], .drawer, .product, .quick-add')) enhance(node);
        node.querySelectorAll?.('form[action*="/cart/add"]').forEach(f => enhance(f));
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
